import { isRequired as isRequiredValidator } from '@monorepo/shared/utils/validators';
import * as Sentry from '@sentry/browser';
import {
  FieldResponse,
  localEquivalentOfUTC,
  NullableBoolean,
  NullableDate,
  NullableString,
  NumericFieldResponse,
  NumericValue,
} from 'mapistry-shared';

export const getValidateFunction = (isRequired: boolean) =>
  isRequired ? isRequiredValidator : undefined;

// initialValue prop on fields prefer undefined over null
export function nullToUndefined<T>(v: T): NonNullable<T> | undefined {
  if (v == null) {
    return undefined;
  }
  // TS doesn't figure this out, so cast
  return v as NonNullable<T>;
}

export function getUnexpectedTypeErrorAndLogToSentry(
  field: FieldResponse,
  value: unknown,
) {
  const err = new Error(
    `Unexpected value provided for ${field.name} (${value})`,
  );
  Sentry.captureException(err, { extra: { field, value } });
  return err;
}

export function stringFieldValueToFormInitialValue(fieldValue?: {
  value: NullableString;
}) {
  return nullToUndefined(fieldValue?.value);
}

export function resourceFieldValueToFormInitialValue(fieldValue?: {
  value: { id: string } | null;
}) {
  return nullToUndefined(fieldValue?.value?.id);
}

export function boolFieldValueToFormInitialValue(fieldValue?: {
  value: NullableBoolean;
}) {
  return fieldValue?.value == null ? undefined : fieldValue.value.toString();
}

export function dateFieldValueToFormInitialValue(fieldValue?: {
  value: NullableDate;
}) {
  return fieldValue?.value == null
    ? undefined
    : localEquivalentOfUTC(new Date(fieldValue.value));
}

export function numberFieldValueToFormInitialValue(
  field: NumericFieldResponse,
  fieldValue?: NumericValue,
) {
  return {
    // the underlying implementation is an HTML input element, so even type='number' works with strings
    initialValue: nullToUndefined(fieldValue?.value?.toString()),
    initialUnits: nullToUndefined(fieldValue?.givenUnits ?? field.units),
  };
}
